import React, { FC } from 'react';
import { Box, ChakraProps, HStack, Text } from '@chakra-ui/react';
import { TokensPair } from '@app/components/TokensPair';
import { IchiBadge } from '@app/screens/pools/components/SingleSidedDeposits/components/IchiBadge';
import { InfoRow } from '@app/screens/positions/components/SpNftControls/InfoRow/InfoRow';
import { formatUSD } from '@app/helpers/formatUSD';
import { toOptionalFixed } from '@app/helpers/format';
import { Vault } from '@app/hooks/plugins/useVaults';

interface Props {
  vaultDetails: Vault | null;
  sx?: ChakraProps;
}

export const VaultInfo: FC<Props> = ({ vaultDetails, sx = {} }) => {
  return (
    <Box
      sx={{
        borderRadius: '12px',
        border: '1px solid',
        borderColor: 'gray.18',
        backgroundColor: 'gray.16',
        padding: 3,
        // marginInline: '12px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        width: '100%',
        ...sx
      }}
    >
      <Box sx={{ padding: '8px' }}>
        <HStack gap="12px" marginBottom="16px">
          <TokensPair
            token0Symbol={vaultDetails?.token0.symbol}
            token1Symbol={vaultDetails?.token1.symbol}
          />
          <Text fontWeight="18px">
            {vaultDetails?.token0.symbol}-{vaultDetails?.token1.symbol}
          </Text>
          <IchiBadge />
        </HStack>

        <InfoRow
          label="Deposit Token"
          value0={vaultDetails?.token0.symbol ?? ''}
        />
        <InfoRow
          label="APR"
          value0={
            vaultDetails?.apr
              ? `${toOptionalFixed(vaultDetails.apr, 2)}%`
              : 'n/a'
          }
        />
        <InfoRow
          label="TVL"
          value0={
            vaultDetails?.tvl ? formatUSD.format(+vaultDetails.tvl) : 'n/a'
          }
        />
      </Box>
    </Box>
  );
};
